import voiceLeftReducer from './module/voiceLeft';
import roomInfoReducer from './module/roomInfo';
import msgInfoReducer from './module/msgInfo';
import onlineInfoReducer from './module/onlineInfo';
import kickInfoReducer from './module/kickInfo';
import msgConfigReducer from './module/msgConfig';
import roomTotalReducer from './module/roomTotal';
import repeatInfoReducer from './module/repeatInfo';
import micInfoReducer from './module/micInfo';
import headInfoReducer from './module/headInfo';
import validateInfoReducer from './module/validateInfo';
import voiceLiveInfoReducer from './module/voiceLiveInfo';
import kalaokInfoReducer from './module/kalaokInfo';
import ortherInfoReducer from './module/ortherInfo';
import agoraInfoReducer from './module/agoraInfo';
import audienceV2Reducer from './module/audienceV2';

const voiceReducers = {
  leftInfo: voiceLeftReducer,
  roomInfo: roomInfoReducer,
  msgInfo: msgInfoReducer,
  onlineInfo: onlineInfoReducer,
  kickInfo: kickInfoReducer,
  msgConfig: msgConfigReducer,
  roomTotal: roomTotalReducer,
  repeatInfo: repeatInfoReducer,
  micInfo: micInfoReducer,
  headInfo: headInfoReducer,
  validateInfo: validateInfoReducer,
  voiceLiveInfo: voiceLiveInfoReducer,
  kalaokInfo: kalaokInfoReducer,
  ortherInfo: ortherInfoReducer,
  agoraInfo: agoraInfoReducer,
  audienceV2: audienceV2Reducer
};

export default voiceReducers;
